import { create } from "zustand";
import { type ITimezone } from "react-timezone-select";

type Props = {
  date?: Date;
  time: string;
  userName: string;
  userEmail: string;
  userTimezone: ITimezone;
  hostTimezone: string;
  setDate: (date?: Date) => void;
  setTime: (time: string) => void;
  setUserName: (name: string) => void;
  setUserEmail: (email: string) => void;
  setTimezone: (tz: ITimezone) => void;
};

export const useMeetingDetails = create<Props>()((set) => ({
  date: undefined,
  time: "",
  userName: "",
  userEmail: "",
  userTimezone: {
    value: Intl.DateTimeFormat().resolvedOptions().timeZone,
    label: Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
  hostTimezone: "Australia/Sydney",
  setDate: (date) => set({ date }),
  setTime: (time) => set({ time }),
  setUserName: (name) => set({ userName: name }),
  setUserEmail: (email) => set({ userEmail: email }),
  setTimezone: (tz) => set({ userTimezone: tz }),
}));
